import React from 'react';
import { useNavigate } from 'react-router-dom';
import './NotFound.scss';

export const NotFound: React.FC = () => {
    const navigate = useNavigate();

    return (
        <div className="not-found">
            <div className="not-found__content">
                <h1 className="not-found__title">404</h1>
                <p className="not-found__text">Страница не найдена</p>
                <button
                    className="not-found__button"
                    onClick={() => navigate('/')}
                >
                    Вернуться на главную
                </button>
            </div>
        </div>
    );
};